export default {
    install(Vue) {
        Vue.config.errorHandler = function (error, vm, info) {
            // Fehlerbehandlungslogik hier
            // Senden Sie die Fehlermeldung über das WebSocket an den Server
            const errorMessage = error.message;
            console.log("UNCAUGHT ERROR MESSAGE: " + errorMessage, error);
        };
    }
};